const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-DocumentsPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */
/** @typedef {(bridge: any) => void} BridgeSelectionCallback */

class HeadlightPaneDocuments extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.Intent = { type: 'none', handler: () =>
		{} };
	}

	closeHandler()
	{
		console.log('[HeadlightPaneDocuments] Documents panel closed.');
		// Reset the intent on close.
		this.resetIntent();
		this.pict.views.DocumentSearch.setMode('none');
	}

	resetIntent()
	{
		this.Intent = { type: 'none', handler: () =>
		{} };
	}

	/**
	 * Render one tab's view without letting its failure take the sibling tabs with it.
	 *
	 * These run as a serial chain, so an unguarded throw in the first tab leaves every later tab
	 * unrendered and the pane's open callback unfired.
	 * @param {string} pViewName - The view to render
	 * @return {void}
	 */
	renderTabView(pViewName)
	{
		try
		{
			this.pict.views[pViewName].renderAsync(false, false, false, false, (pError) =>
			{
				if (pError)
				{
					this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
					return;
				}
				this.log.info(`${pViewName} view rendered`);
			});
		}
		catch (pError)
		{
			this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
		}
	}

	onAfterRenderAsync(pCallback)
	{
		// set the callback that runs when the search results are returned
		this.pict.views.DocumentSearch.setDocumentSearchResultsCallback((pResults) =>
		{
			// collapse the filter panel
			this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('DocumentSearchFilters', 'close');
			// render the pagination controls
			this.pict.views.DocumentSearch.renderAsync('DocumentSearch-Results', '#DocumentSearch-Results-Container', false, () =>
			{
				// TODO: is this the proper location for this? Should we be using the Entity object?
				const tmpDocuments = this.AppData?.DocumentData;
				if (tmpDocuments)
				{
					// for each Document, if the Document is already included, toggle the button to "on"
					pResults.forEach((pResult) =>
					{
						if (tmpDocuments.find((obs) => obs.IDDocument === pResult.IDDocument))
						{
							document.querySelector(`[data-document-add-context="${pResult.IDDocument}"]`)?.classList?.add('is-active');
						}
					});
				}
			});
		});
		// set the default search filter options for the Document search view
		this.pict.views.DocumentSearch.setCurrentSearchFilters({
			PageSize: 30,
		});
		// render each tab's view; a failure in one must not strand the others
		this.renderTabView('DocumentSearch');
		this.renderTabView('DocumentCreate');
		this.renderTabView('DocumentCurrent');

		if (!this.pict.AppData.DocumentData?.ReportData?.IDDocument)
		{
			const currentTab = document.getElementById('HeadlightPanels-DocumentPanel-Current-Tab');
			if (currentTab)
			{
				currentTab.classList.add('is-hidden');
			}
		}

		// the panel opens in this callback, so we need to wait for it to open before we can build the included Documents list
		if (pCallback)
		{
			pCallback();
		}
	}
}

module.exports = HeadlightPaneDocuments;
// additional view-specific templates
const viewSpecificTemplates = [
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;
